import '../../css/style.scss'
import {UIWProfileController} from './UIWProfileController'
import {UIWHeaderController} from '../ui_html/header/UIWHeaderController'
import {UISidebarController} from '../ui_html/sidebar/UISidebarController'
import {EntryShared} from '../../../shared/scripts/EntryShared'
import {EntrySingletonPageShared} from '../../EntrySingletonPageShared'
import {UIWManagerEvents} from '../ui_html/UIWManagerEvents'

class EntryProfile extends EntryShared {
    constructor() {
        super()
        void this.init()
    }

    // eslint-disable-next-line class-methods-use-this
    async init() {
        EntryShared.initializeAudio()
        await EntryShared.initializeEntry()
        this.initializeUIManagerEvents(new UIWManagerEvents(undefined))

        new UIWProfileController()

        const headerController = new UIWHeaderController()
        new UISidebarController()

        EntrySingletonPageShared.initializeSocketAndGeneralServices(headerController)
    }
}

new EntryProfile()
